import type { EmployeePermissionScope } from '@gokrew/models/employee-permissions';
import type { ApiResponse } from '@gokrew/models/generic';
import api from './client';

export type EmployeeScopesResponse = ApiResponse<{
  companyId: string;
  scopes: EmployeePermissionScope[];
}>;

/**
 * Fetches the employee permission scopes for the logged-in employee
 *
 * @returns A promise that resolves with the employee's assigned permission scopes
 */
export async function getEmployeeScopes() {
  const { data } = await api.get<EmployeeScopesResponse>('/employee/scopes');
  return data;
}
